import { z } from 'zod';

export const DEFAULT_MAX_NO_OF_FILES = 10;
export const DEFAULT_MAX_FILE_SIZE = 10000000;
export const DEFAULT_MAX_FILE_SIZ_IN_MB = DEFAULT_MAX_FILE_SIZE / 1000000;

export const multiFileValidator = z
  .any()
  .refine((files) => (files || []).length <= DEFAULT_MAX_NO_OF_FILES, {
    message: 'FILE_VALIDATOR.TOO_MANY_FILES',
    params: { n: DEFAULT_MAX_NO_OF_FILES },
  })
  .refine(
    (files: FileList) =>
      Array.from(files || []).every((file) => file.size <= DEFAULT_MAX_FILE_SIZE),
    {
      message: 'FILE_VALIDATOR.FILE_TOO_BIG',
    },
  )
  .refine(
    (files: FileList) =>
      Array.from(files || []).every((file) => ALL_ACCEPTED_MIME_TYPES.includes(file.type)),
    {
      message: 'FILE_VALIDATOR.WRONG_FILE_TYPE',
      params: {
        formats: getExtensionsFromMimeTypeArray(ALL_ACCEPTED_MIME_TYPES),
      },
    },
  );
